import { Builder } from "@builder.io/react";
import ProductsHero from "components/blocks/hero/ProductsHero";
import { BOOK_CALL_LINK } from "components/constants";
import { toMutable } from "types/common";
import gradientheroleft from "./images/gradient-hero-left.svg";
import icon from "./images/yieldManager.svg";

const inputs = [
    {
        name: "buttonTo",
        type: "text",
        defaultValue: BOOK_CALL_LINK,
        required: true,
    },
    {
        name: "buttonTitle",
        type: "text",
        defaultValue: "Book a demo",
        required: true,
    },
    {
        name: "description",
        type: "longText",
        defaultValue:
            "Empower your team to easily test scenarios, preview and evaluate the financial impact of constant changes and make successful decisions. With deep level data in real-time? Of course!",
    },
    {
        name: "heading",
        type: "text",
        defaultValue: "Boosting agility and control",
        required: true,
    },
    {
        name: "imageOrGif",
        type: "file",
        allowedFileTypes: ["jpg", "png", "jpeg", "gif", "svg"],
        required: true,
    },
    {
        name: "imageOrGifHover",
        type: "file",
        allowedFileTypes: ["jpg", "png", "jpeg", "gif", "svg"],
    },
    {
        name: "imageOrGifAlt",
        type: "text",
        defaultValue: "Gain Bidder Intelligence",
    },
] as const;

const YieldManagerProductHero: BFC<typeof inputs> = ({
    heading,
    description,
    buttonTitle,
    buttonTo,
    imageOrGif,
    imageOrGifHover,
    imageOrGifAlt,
}) => {
    return (
        <ProductsHero
            heading={heading}
            description={description ?? ""}
            buttonTitle={buttonTitle}
            buttonTo={buttonTo}
            heroimage={imageOrGif}
            heroimageHover={imageOrGifHover}
            heroimageAlt={imageOrGifAlt}
            showForm={false}
            buttonStyle="btn--yellow-red"
            icon={icon}
            iconTitle="Yield Manager"
            gradient={{
                right: "",
                rightTop: "-130px",
                rightBottom: "",
                left: gradientheroleft,
                leftTop: "-280px",
                leftBottom: "",
            }}
            showWinner="yieldManager"
        />
    );
};

Builder.registerComponent(YieldManagerProductHero, {
    name: "YieldManagerProductHero",
    inputs: toMutable(inputs),
});
